import {createSlice} from '@reduxjs/toolkit';
import {DefaultRootState} from 'react-redux';

import {extendedAPI} from './api';

import {ReportSerializedType} from 'sweet-types';

export interface ReportsState {
  reportById: {[slug: string]: ReportSerializedType};
}

const initialState: ReportsState = {
  reportById: {},
};

const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    // setReports: (state, action: PayloadAction<ReportSerializedType[]>) => {
    //   state.reports = action.payload;
    // },
  },
  extraReducers: (builder) =>
    builder
      .addMatcher(
        extendedAPI.endpoints.getReports.matchFulfilled,
        (state, {payload}) => {
          for (const report of payload.results) {
            state.reportById[report.slug] = report;
          }
        }
      )
      .addMatcher(
        extendedAPI.endpoints.getReport.matchFulfilled,
        (state, {payload: report}) => {
          state.reportById[report.slug] = report;
        }
      ),
});

//export const {setReports} = reportsSlice.actions;

export const reportsReducer = reportsSlice.reducer;

export const getReportBySlugSelector =
  (slug: string) =>
  (state: DefaultRootState): ReportSerializedType | undefined =>
    state.reports.reportById[slug];
